module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component"
  }, [_c('div', {
    staticClass: "body",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.expand()
      }
    }
  }, [_c('div', {
    class: 'image item-image default-image ' + (_vm.level.info.video ? 'has-video' : '') + ' color-' + _vm.level.info.level + ' ' + (
      (_vm.level.info.minage >= 7 || _vm.level.info.is_private) ? 'young-adults' : 'children'
    ),
    style: ('background-image:url(' + _vm.level.info.image + ')')
  }, [(_vm.level.info.show_bjornbusen) ? _c('div', {
    class: {
      bjorbusen: true, 'has-subtitle': _vm.level.info.sub_title_2
    },
    style: ('background-image:url(https://static.booking.branasgruppen.se/static/img/Skidskola/skidskola-bjornbusen.png)')
  }, [_c('h2', {
    class: {
      'has-subtitle': _vm.level.info.sub_title_2
    }
  }, [_vm._v(_vm._s(_vm.level.info.sub_title_1)), (_vm.level.info.sub_title_2) ? _c('span', {
    staticClass: "smaller"
  }, [_vm._v(_vm._s(_vm.level.info.sub_title_2))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.level.info.show_badge) ? _c('span', {
    class: 'badge badge-' + ((_vm.level.info.level_virtual || '').match(/snolek$/) ? 'purple' : _vm.level.info.level)
  }, [_vm._v(_vm._s(_vm.level.info.level_name))]) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'bike school overview') ? _c('div', {
    staticClass: "snow-bg"
  }) : _vm._e(), _vm._v(" "), (_vm.level.info.video) ? _c('div', {
    class: 'video-overlay ' + (_vm.level.info.show_bjornbusen ? 'video-overlay--bottom-right' : '')
  }, [_c('i', {
    staticClass: "fal fa-play-circle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openVideo($event)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "details-start"
  }, [_c('p', {
    staticClass: "area-title",
    staticStyle: {
      "font-size": "1px"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.level.info.special_title))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('p', [_vm._v(_vm._s(_vm.level.info.description))])]), _vm._v(" "), (_vm.level.info.prerequisites) ? _c('div', {
    staticClass: "description"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('skischool.prerequisites')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.level.info.prerequisites))])]) : _vm._e()])])]), _vm._v(" "), _c('SkiSchoolListUnitsList', {
    ref: "unitList",
    attrs: {
      "courses": _vm.level.courses,
      "info": _vm.level.info
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-068ede17"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/SkiSchool/SkiSchoolListPool.vue
// module id = 888
// module chunks = 0